export default __webpack_public_path__ + "static/clientGrade-55e37fbd9f6a9fdb726218037c243fac.png";